export default __webpack_public_path__ + "static/media/640_business05-fr-mobile.7206596f.png";